import type { RouteLocationNormalized } from 'vue-router';
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { routenames } from '../routenames';
import { TAB_PREFIX } from '@/components/confirmationModals/useFormConfirmationModal';

export async function installationGuard(to: RouteLocationNormalized) {
  const authenticationStore = useAuthenticationStore();

  if (to.name === routenames.installation) {
    if (authenticationStore.isAuthenticated) {
      return { name: routenames.signOut };
    }

    if (
      to.hash !== `#${TAB_PREFIX}activation` &&
      !authenticationStore.session?.isInstallationActivated
    ) {
      return {
        name: routenames.installation,
        hash: `#${TAB_PREFIX}activation`,
      };
    }

    if (!authenticationStore.session?.isFirstTimeInstallation) {
      return {
        name: routenames.home,
      };
    }
  } else if (authenticationStore.session?.isFirstTimeInstallation) {
    return {
      name: routenames.installation,
    };
  }
}
